// 2026-05-26 - FormuLearning - 새 프로젝트 생성 모달
// 2026-09-21 수정 - 이슈 #77(G6): 입력 `API Name (Drug)` → **Description**(여러 줄, memo 로 저장 · M901-06).
//   폴더 우클릭 «New Project Here» 로 열면 그 폴더에 만든다(REQ-UX-31) — 제목 아래 경로 표기.
// 파일 위치: frontend/src/features/project/ProjectNewModal.tsx

import { useState } from 'react'
import Modal from '../../components/feedback/Modal'
import { useProjectStore } from '../../stores/projectStore'
import { useUiStore } from '../../stores/uiStore'
import { toast } from '../../stores/toastStore'
import { apiErrorMessage } from '../../lib/apiError'
import { folderPath } from './folderTree'

export default function ProjectNewModal() {
  const { activeModal, closeModal, newProjectFolderId } = useUiStore()
  const createProject = useProjectStore((s) => s.createProject)
  const folders = useProjectStore((s) => s.folders)
  const [name, setName] = useState('')
  const [description, setDescription] = useState('')
  const [loading, setLoading] = useState(false)

  const location = newProjectFolderId ? folderPath(new Map(folders.map((f) => [f.id, f])), newProjectFolderId) : ''

  const handleCreate = async (e: React.FormEvent) => {
    e.preventDefault()
    if (!name.trim()) return
    setLoading(true)
    try {
      await createProject(name.trim(), description.trim() || undefined, newProjectFolderId)
      setName('')
      setDescription('')
      closeModal()
    } catch (err) {
      toast(apiErrorMessage(err, '프로젝트를 만들지 못했습니다.'), 'warn')
    } finally {
      setLoading(false)
    }
  }

  return (
    <Modal open={activeModal === 'project-new'} onClose={closeModal} title="New Project">
      <form onSubmit={handleCreate} className="space-y-4">
        {location && (
          <p className="text-[11px] text-text-secondary">
            in <span className="font-medium text-text-body">📁 {location}</span>
          </p>
        )}
        <div>
          <label className="mb-1 block text-xs font-medium text-text-secondary">Project Name *</label>
          <input
            type="text"
            value={name}
            onChange={(e) => setName(e.target.value)}
            maxLength={200}
            className="w-full rounded-md border bg-bg-input px-3 py-2 text-sm text-text-body outline-none"
            style={{ borderColor: 'var(--border-soft)' }}
            placeholder="e.g. Fenofibrate 160mg"
            required
          />
        </div>
        <div>
          <label className="mb-1 block text-xs font-medium text-text-secondary">Description</label>
          <textarea
            value={description}
            onChange={(e) => setDescription(e.target.value)}
            rows={3}
            className="w-full resize-y rounded-md border bg-bg-input px-3 py-2 text-sm text-text-body outline-none"
            style={{ borderColor: 'var(--border-soft)' }}
            placeholder="e.g. Fenofibrate IR tablet — reformulation study"
          />
        </div>
        <div className="flex justify-end gap-2 pt-2">
          <button
            type="button"
            onClick={closeModal}
            className="rounded-md px-4 py-2 text-xs text-text-secondary transition-colors hover:bg-bg-input"
          >
            Cancel
          </button>
          <button
            type="submit"
            disabled={loading || !name.trim()}
            className="rounded-md bg-accent-purple px-4 py-2 text-xs font-semibold text-[#1a1b1e] transition-opacity hover:opacity-90 disabled:opacity-50"
          >
            {loading ? 'Creating...' : 'Create'}
          </button>
        </div>
      </form>
    </Modal>
  )
}
